<template>
  <div class="unlimited">
    <section class="retry-area" v-if="responseError">
      <h3 class="retry-area__ttl">通信に失敗しました</h3>
      <a href="javascript:void(0);" @click="getStatus" class="btn-retry btn-retry--short">リトライ</a>
    </section>
    <div v-else>
      <section class="unlimited-keyvisual">
        <img v-bind:src="require('../../../../static/img/subscription_detail1.png')" alt="" class="unlimited-keyvisual__bg">
        <h2 class="unlimited-block__title">AI × 良質な英語教材<br>1ヶ月でTOEIC96点UP</h2>
      </section>

      <main class="unlimited-main">
        <section class="unlimited-block">
          <section class="unlimited-tile">
            <div class="unlimited-tile__img" style="padding: 0 10px;"><img v-bind:src="require('../../../../static/img/subscription_detail2.png')" alt=""></div>
            <h2 class="unlimited-block__title">リアルタイムスコア予測で<br>スコアUPがすぐわかる</h2>

            <p class="unlimited-tile__body">1億問以上の解答データにもとづき、<br>AIが予測スコアをリアルタイムに更新します。</p>
            <p class="unlimited-tile__body__red">本番との誤差6%</p>
          </section>
        </section>
        <section class="unlimited-border">
        </section>
        <section class="unlimited-block">
          <section class="unlimited-tile">
            <div class="unlimited-tile__img"><img v-bind:src="require('../../../../static/img/subscription_detail3.png')" alt=""></div>
            <h2 class="unlimited-block__title">最適な問題をAIがレコメンド</h2>

            <p class="unlimited-tile__body">20,000問以上の中から、難易度、習得状況などを踏まえて、あなたに最適な問題をAIがレコメンドします。</p>
            <p class="unlimited-tile__body__red">1日30問の学習でTOEIC予測スコアが月平均96点UP</p>
          </section>
        </section>
        <section class="unlimited-border">
        </section>

        <section class="unlimited-block">
          <section class="unlimited-tile">
            <div class="unlimited-tile__img"><img v-bind:src="require('../../../../static/img/subscription_detail1.png')" alt=""></div>
            <h2 class="unlimited-block__title">Unlimited教材使い放題</h2>

            <p class="unlimited-tile__body">良質な教材{{unlimited_book_count}}タイトルがすべて使い放題。<br>好きな教材がいつでもご利用いただけます。</p>
            <router-link :to="{ name: 'UnlimitedTextList' }"><p class="unlimited-tile__body__red__link">Unlimited教材一覧</p></router-link>
          </section>
        </section>
        <section class="unlimited-border">
        </section>

        <section class="unlimited-block" v-show="!skipPremium">
          <section class="unlimited-tile">
            <div class="unlimited-tile__img" style="padding: 10px 50px;"><img v-bind:src="require('../../../../static/img/subscription_detail4.png')" alt=""></div>
            <h2 class="unlimited-block__title">プレミアム機能も利用可能</h2>

            <p class="unlimited-tile__body">辞書、MY単語帳、ディクテーション・シャドーイングなど、Premium機能もすべてご利用いただけます。</p>
            <router-link :to="{ name: 'PremiumPlan' }"><p class="unlimited-tile__body__red__link">プレミアム機能とは</p></router-link>
          </section>
        </section>

        <section class="unlimited-block" style="padding: 10px 10px;">
          <section class="unlimited-tile">
            <div class="payment-policy">
              ・この定期購読は自動継続購読になります。アプリを削除するだけではサービスは解約されませんのでご注意ください。<br>
              ・購読期間終了の24時間前までであれば解約（自動継続購読を停止）できます。<br>
              ・解約手続きはWebストアの「アカウント」から行えます（詳細は<a href="https://www.globeejapan.com/faq.html" target="_blank">FAQ</a>に記載）。<br>
              ・自動継続課金は購読期間終了前24時間以内に自動で行われます。
            </div>
          </section>
        </section>
      </main>


      <section class="unlimited-guide unlimited-guide--fixed">
        <div class="unlimited-discount-header" v-if="isDicsountValid">
          <div class="unlimited-discount-top">
            今だけ定価より{{subscriptions[0].coupon_discount_ratio * 100}}%OFFキャンペーン実施中！
          </div>
          <div class="unlimited-discount-sub">
            *本キャンペーン価格は初回契約期間(1ヶ月/3ヶ月/1年)のみ有効です。契約更新時には通常価格(定価)にて更新されます。
          </div>
        </div>
        <section class="unlimited-types">
          <div
            class="unlimited-type"
            :class="{ 'is-active': activeUnlimitedType === 0 }"
            @click="activeUnlimitedType = 0"
          >
            <p class="unlimited-type__title">{{subscriptions[0].main_text}}</p>

            <div v-if="isDicsountValid">
              <p class="unlimited-type__subtitle">{{separate(subscriptions[0].discount_price_per_month)}}円</p>
              <p class="unlimited-type__bottom">定価{{separate(subscriptions[0].price_per_month)}}円</p>
            </div>
            <div v-else>
              <p class="unlimited-type__subtitle">{{separate(subscriptions[0].price_per_month)}}円</p>
            </div>

            <div class="unlimited-type__border" v-show="activeUnlimitedType === 0"></div>
          </div>
          <div
            class="unlimited-type"
            :class="{ 'is-active': activeUnlimitedType === 1 }"
            @click="activeUnlimitedType = 1">
            <p class="unlimited-type__title">{{subscriptions[1].main_text}}(月{{subscriptions[1].discount_ratio}}%お得)</p>

            <div v-if="isDicsountValid">
              <p class="unlimited-type__subtitle">{{separate(subscriptions[1].discount_amount_price_num)}}円<span style="font-size:80%;">({{separate(subscriptions[1].discount_price_per_month)}}円/月)</span></p>
              <p class="unlimited-type__bottom">定価{{separate(subscriptions[1].amount_price_num)}}円</p>
            </div>
            <div v-else>
              <p class="unlimited-type__subtitle">{{separate(subscriptions[1].amount_price_num)}}円/月({{separate(subscriptions[1].price_per_month)}}円/月)</p>
            </div>

            <div class="unlimited-type__border" v-show="activeUnlimitedType === 1"></div>
          </div>
          <div
            class="unlimited-type"
            :class="{ 'is-active': activeUnlimitedType === 2 }"
            @click="activeUnlimitedType = 2"
          >
            <p class="unlimited-type__title">{{subscriptions[2].main_text}}(月{{subscriptions[2].discount_ratio}}%お得)</p>

            <div v-if="isDicsountValid">
              <p class="unlimited-type__subtitle">{{separate(subscriptions[2].discount_amount_price_num)}}円<span style="font-size:80%;">({{separate(subscriptions[2].discount_price_per_month)}}円/月)</span></p>
              <p class="unlimited-type__bottom">定価{{separate(subscriptions[2].amount_price_num)}}円</p>
            </div>
            <div v-else>
              <p class="unlimited-type__subtitle">{{separate(subscriptions[2].amount_price_num)}}円/月({{separate(subscriptions[2].price_per_month)}}円/月)</p>
            </div>

            <div class="unlimited-type__border" v-show="activeUnlimitedType === 2"></div>
          </div>
        </section>
        <section class="unlimited-upgrade">
          <h2 class="unlimited-upgrade__title">{{planTitleEn}} <br class="sp-on">{{planTitle}}</h2>
          <div class="unlimited-upgrade__body">
            <a href="javascript:void(0);" @click="onClickUpgrade" class="btn-upgrade">アップグレード</a>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import {credit, subscriptions_prefix, unlimited_subscriptions_prefix } from '../../../constants';

  export default {
    title: 'アンリミテッドプラスプラン',
    headerTitle: 'アンリミテッドプラスプラン',
    headerType: 'historyBack',
    resetScrollView: true,
    components: {
    },
    data() {
      return {
        responseError: false,
        activeUnlimitedType: 2,
        fixedMenuShown: false,
        skipPremium: false
      }
    },
    beforeRouteUpdate (to, from, next) {
      if (to.name === 'UnlimitedPlus') {
        this.checkSkipPremium(to.query);
        this.getStatus();
      }
      next();
    },
    created() {
      this.getStatus();
    },
    mounted() {
      this.checkSkipPremium(this.$route.query);
      this.setFixedContents();
    },
    methods: {
      separate(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      },
      onClickUpgrade() {
        const subscription = this.subscriptions[this.activeUnlimitedType];
        const product_id = subscription.product_id;
        const settings = this.$store.getters.userSettings.user;
        const isCreditCardAvailable = ('sbps_payment_type' in settings && settings.sbps_payment_type === credit);
        if (isCreditCardAvailable) {
          let amount = subscription.amount_price_num;
          if (subscription.discount_amount_price_num) {
            amount = subscription.discount_amount_price_num;
          }
          let show_amount = this.separate(amount);
          let show_text = subscription.name_plan + 'を購入してもよろしいですか？\n決済金額：' + show_amount + "円";
          if (!confirm(show_text)) {
            return;
          }
          //クレカ購入済みの場合はその場で決済させる
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("purchaseUnlimitedByToken", {
            ignore_token: true,
            product_id: product_id
          }).then(data => {
            if (data.result) {
              //購入成功
              this.$store.dispatch("hideLightBox");
              this.$store.dispatch("showLightBox", "unlimitedResult");
              //Homeに戻す
              this.$router.push({name: 'rankingHome'});
            } else {
              this.$store.dispatch("hideLightBox");
              alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
            alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
          });
        } else {
          this.$router.push({name: 'UnlimitedCreditCard', params: { id: product_id.replace(unlimited_subscriptions_prefix, '') }});
        }

      },
      checkSkipPremium(query) {
        if (query && query.skipPremium) {
          this.skipPremium = true;
          this.$store.dispatch("changeHeaderTitle", `アンリミテッドプラン`);
        } else {
          this.skipPremium = false;
          this.$store.dispatch("changeHeaderTitle", `アンリミテッドプラスプラン`);
        }
      },
      getStatus() {
        this.$store.dispatch("changeLoadingCondition", true);
        let token = "";
        if (this.$route.query.token) {
          token = this.$route.query.token;
        }
        this.$store.dispatch('getUserSettings', {token:token})
          .then(data => {
            this.responseError = data === 'error';
            if (data.user.sbps_payment_type && data.user.sbps_payment_type === 'credit') {
              this.isCreditAvailabel = true;
            }
            this.$store.dispatch("changeLoadingCondition", false);
            //ログイン成功の場合はログイン処理を行う
            if (data.has_logined) {
              if (data.login_info) {
                this.$store.dispatch("setLogin", data.login_info);
              }
            }
            //Premium購入済みならUnlimited画面に飛ばす
            if (data.using_plan && data.using_plan.product_id !== "free") {
              if (!this.skipPremium) {
                this.$router.replace({name: 'UnlimitedPlus', query:{skipPremium:true}})
              }
            }

          })
          .catch(() => {
            this.responseError = true;
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      setFixedContents() {
        $(window).on("scroll", (e) => {
          let bodyScrollTop = $(e.target).scrollTop();
          let startPosition = $(".unlimited-main").offset().top;
          let endPosition = $(".footer").offset().top;
          if (bodyScrollTop > startPosition) {
            this.fixedMenuShown = true;
          } else {
            this.fixedMenuShown = false;
          }
        });
      }
    },
    computed: {
      isDicsountValid() {
        if (this.subscriptions && this.subscriptions.length > 0) {
          return (this.subscriptions[0]["coupon_discount_ratio"])
        }
        return false;
      },
      planTitleEn() {
        if (this.skipPremium) {
          return "abceed unlimited"
        } else {
          return "abceed unlimited plus"
        }
      },
      planTitle() {
        if (this.skipPremium) {
          return "アンリミテッド会員"
        } else {
          return "アンリミテッドプラス会員"
        }
      },
      subscriptions() {
        if (this.skipPremium) {
          return this.$store.getters.userSettings.unlimited_subscriptions;
        } else {
          return this.$store.getters.userSettings.unlimited_premium_subscriptions;
        }
      },
      unlimited_book_count() {
        return this.$store.getters.userSettings.unlimited_book_count;
      },
      unlimited_question_count() {
        return this.$store.getters.userSettings.unlimited_question_count;
      }
    }
  }
</script>

<style scoped lang="scss">

.unlimited {
  width: 800px;
  margin: 0 auto;
  @media screen and (max-width: 768px){
    width: auto;
  }
}

.unlimited-keyvisual {
  padding-top: 20px;
  padding-bottom: 20px;
  background: white;
  position: relative;
  &__bg {
    width: 100%;
    @media screen and (max-width: 768px){
      height: auto;
    }
  }
  &__contents {
    position: absolute;
    width: 800px;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    @media screen and (max-width: 768px){
      top: 22px;
      width: 100%;
    }
  }
}

.unlimited-intro {
  &__title {
    font-size: 54px;
    font-weight: bold;
    margin-bottom: 4px;
    text-align: left;
    margin-left: 30px;
    @media screen and (max-width: 768px){
      font-size: 42px;
      line-height: 1.3;
      margin-left: 15px;
    }
  }
  &__subtitle {
    font-size: 24px;
    text-align: left;
    margin-left: 25px;
    @media screen and (max-width: 768px){
      font-size: 18px;
      margin-left: 10px;
    }
  }
}

.unlimited-types {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unlimited-border {
  width: 100%;
  background-color: #F1F1F1;
  height: 20px;
}
.unlimited-type {
  font-size: 14px;
  background-color: #fff;
  color: rgb(158, 158, 158);
  flex: 1;
  padding: 9px 0;
  line-height: 1.5;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  &.is-active {
    color: #FF4247;
  }
  &__discount {
    position: absolute;
    height: 24px;
    line-height: 24px;
    top: -24px;
    left: 0;
    width: 100%;
    background-color: rgb(35, 25, 22);
    color: #fff;
  }
  &__title {
    font-size: 12px;
  }
  &__border {
    position: absolute;
    bottom: 5px;
    height: 3px;
    width: 66%;
    left: 17%;
    background-color: #FF4247;
  }
  &__bottom {
    font-size: 12px;
  }
}

.unlimited-discount-header {
  background-color: white;
  padding: 10px 0 0 0;
}

.unlimited-discount-top {
  font-size: 18px;
  color: #FF4247;
  font-weight: 500;
  margin: 0 10px;
}

.unlimited-discount-sub {
  font-size: 12px;
  text-align: left;
  margin: 0 15px;
  color: #757575;
}

.unlimited-upgrade {
  background-color: #F1F1F1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  @media screen and (max-width: 768px){
    padding: 10px 10px;
  }
  &__title {
    width: calc(100% - 130px);
    text-align: left;
    font-size: 18px;
    margin-left: 10px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__body {
    width: 130px;
  }
  .btn-upgrade {
    border-radius: 20px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FF4247;
    padding: 8px 3px;
  }
}

.unlimited-guide {
  &--fixed {
    position: fixed;
    width: 800px;
    left: 50%;
    margin-left: -400px;
    bottom: 0;
    @media screen and (max-width: 768px){
      width: 100%;
      left: 0;
      margin: 0;
    }
  }
}

.unlimited-main {
  margin-top: 20px;
  background-color: #fff;
  padding: 40px 100px;
  @media screen and (max-width: 768px){
    padding: 20px 0;
  }
}

.unlimited-block {
  padding-top: 10px;
  margin-bottom: 60px;
  @media screen and (max-width: 768px){
    margin-bottom: 30px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  &__title {
    margin-top: 20px;
    font-size: 26px;
    font-weight: bold;
    text-align: center;
  }
}

.unlimited-tile-body {
  &__link {
    text-align: right;
    padding-top: 10px;
    @media screen and (max-width: 768px){
      padding-top: 6px;
    }
    a {
      color: #FF4247;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.unlimited-tile {
  border-radius: 8px;
  overflow: hidden;
  &__img {
    img {
      width: 100%;
    }
  }
  &__body {
    font-size: 21px;
    padding: 30px;
    text-align: center;
    @media screen and (max-width: 768px){
      font-size: 16px;
      padding: 12px;
    }

    &__red {
      color: #FF223C;
      &__link {
        color: #FF223C;
        text-decoration: underline;
      }
    }
  }
}

.noneed-premium {
  padding: 30px 0 10px;
  @media screen and (max-width: 768px){
    padding: 20px 0 10px;
  }
  a {
    color: #FF4247;
    font-size: 18px;
    text-decoration: underline;
    @media screen and (max-width: 768px){
      font-size: 16px;
    }
    &:hover {
      text-decoration: none;
    }
  }
}

.payment-policy {
  margin-top: 20px;
  text-align: left;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/campainPage/unlimited/Plus.vue